module.exports = __webpack_public_path__ + "img/129.8.9451d10b.png";